import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";
import ResultsTotal from "./ResultsTotal";
import { selectTeams } from "../../../../../../redux/slices/teamsSlice";

const ConnectedResultsTotal = ({ total }) => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );
    const {
        options: {
            joinTeamModal: { searchResultsLabel = "teams" },
        },
    } = control;

    const teams = useSelector(selectTeams);
    const isVisible = teams && teams.length > 0;

    const resultsTotalProps = {
        isVisible,
        searchResultsLabel,
        total,
    };
    return <ResultsTotal {...resultsTotalProps} />;
};

ConnectedResultsTotal.propTypes = {
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ConnectedResultsTotal;
